var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9073_10468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9073_10468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 22.3125V28C19.6875 28.3719 19.8134 28.6835 20.0651 28.9349C20.3168 29.1866 20.6286 29.3125 21.0004 29.3125C21.3726 29.3125 21.6842 29.1866 21.9354 28.9349C22.1868 28.6835 22.3125 28.3719 22.3125 28V22.3125H28C28.3719 22.3125 28.6835 22.1866 28.9349 21.9349C29.1866 21.6832 29.3125 21.3714 29.3125 20.9996C29.3125 20.6274 29.1866 20.3158 28.9349 20.0646C28.6835 19.8132 28.3719 19.6875 28 19.6875H22.3125V14C22.3125 13.6281 22.1866 13.3165 21.9349 13.0651C21.6832 12.8134 21.3714 12.6875 20.9996 12.6875C20.6274 12.6875 20.3158 12.8134 20.0646 13.0651C19.8132 13.3165 19.6875 13.6281 19.6875 14V19.6875H14C13.6281 19.6875 13.3165 19.8134 13.0651 20.0651C12.8134 20.3168 12.6875 20.6286 12.6875 21.0004C12.6875 21.3726 12.8134 21.6842 13.0651 21.9354C13.3165 22.1868 13.6281 22.3125 14 22.3125H19.6875ZM21.0031 37.625C18.7036 37.625 16.5422 37.1887 14.5189 36.316C12.4956 35.4433 10.7357 34.259 9.23912 32.7631C7.74258 31.2671 6.55769 29.5079 5.68444 27.4855C4.81148 25.4631 4.375 23.3023 4.375 21.0031C4.375 18.7036 4.81133 16.5422 5.684 14.5189C6.55667 12.4956 7.74098 10.7357 9.23694 9.23912C10.7329 7.74258 12.4921 6.55769 14.5145 5.68444C16.5369 4.81148 18.6977 4.375 20.9969 4.375C23.2964 4.375 25.4578 4.81133 27.4811 5.684C29.5044 6.55667 31.2643 7.74098 32.7609 9.23694C34.2574 10.7329 35.4423 12.4921 36.3156 14.5145C37.1885 16.5369 37.625 18.6977 37.625 20.9969C37.625 23.2964 37.1887 25.4578 36.316 27.4811C35.4433 29.5044 34.259 31.2643 32.7631 32.7609C31.2671 34.2574 29.5079 35.4423 27.4855 36.3156C25.4631 37.1885 23.3023 37.625 21.0031 37.625Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.fc5481debbef60b990cd1f12b9fc2376.svg";
export { ForwardRef as ReactComponent };